import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { AccountStateService } from '../../../services/account-state.service';

@Component({
  selector: 'avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './avatar.component.scss',
})
export class AvatarComponent {
  private _accountStateService = inject(AccountStateService);

  public initials = computed(() => {
    if (!this._accountStateService.$account()) return null;

    const { firstname, lastname } = this._accountStateService.$account();
    if (firstname && lastname) return firstname.charAt(0).toUpperCase() + lastname.charAt(0).toUpperCase();

    return firstname.charAt(0).toUpperCase() || lastname.charAt(0).toUpperCase() || null;
  });
}
